import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=5ea40256&scoped=true"
import script from "./sku.vue?vue&type=script&lang=ts"
export * from "./sku.vue?vue&type=script&lang=ts"
import style0 from "./sku.vue?vue&type=style&index=0&id=5ea40256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea40256",
  null
  
)

export default component.exports